import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { MaterialComponentsModule } from '../material/material-components.module';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { HeaderComponent } from './components/header/header.component';
import { SwitchOrganizationComponent } from './components/profile/switch-organization/switch-organization.component';
import { UserProfileMenuComponent } from './components/profile/user-profile-menu/user-profile-menu.component';
import { FeedbackDialogComponent } from './components/header/feedback-dialog/feedback-dialog.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SideNavComponent,
    SwitchOrganizationComponent,
    UserProfileMenuComponent,
    FeedbackDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialComponentsModule,
    RouterModule,
    SharedModule,
    MatDialogModule,
  ],
  exports: [HeaderComponent, SideNavComponent],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class LayoutModule {}
